export const mobileSlider = (theme) => ({
    container: {
        overflow: "hidden",
    },
    sliderButton: {
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    sliderNextButton: {
        borderRadius: "100%",
        border: `3px solid ${theme.customPalette.secondaryYellowYButtons}`,
    },
    slider: {
        "& .slick-list": {
            overflow: "visible",
        },
        marginBottom: theme.spacing(3),
    },
});
